import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { CenterFrameLayout } from 'Layouts';
import { signOut } from 'State/User';
import { handleSignOut } from 'Utils/MVPD';
import { segmentTrackEvent, tealiumTrackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { logger } from 'Utils/Logger';
import { setLocation } from 'Utils/Path';
import { useStore } from 'Hooks/useStore';

export function SignOutContainer() {
  const [path, setPath] = useState('');
  const { defaultConfig } = useStore('appConfig');
  const { rootDomain } = defaultConfig;

  useEffect(() => {
    async function logout() {
      logger.started('signout');
      segmentTrackEvent(TRACKING_ENUMS.EVENT_LOGOUT_STARTED);
      tealiumTrackEvent(TRACKING_ENUMS.EVENT_LOGOUT);
      try {
        await handleSignOut({ profileSignOut: () => signOut() });
        segmentTrackEvent(TRACKING_ENUMS.EVENT_LOGOUT_COMPLETED);
        segmentTrackEvent(TRACKING_ENUMS.EVENT_PROFILE_LOGGED_OUT);
      } catch (error) {
        logger.error('signout', error);
      }

      // set redirect path
      const returnToParams = window.location.href.split('return_to=');
      const isLocalhost = window.location.hostname.includes('local');
      let path = returnToParams[1] || !isLocalhost ? rootDomain : '/';
      if (returnToParams.length > 2) {
        path += `return_to=${returnToParams[2]}`;
      }
      const isExternalLink = !!path.match(/http/i);

      if (isExternalLink || path === rootDomain) {
        setLocation(path);
      } else {
        setPath(path);
      }
    }
    logout();
  }, [rootDomain]);

  // for internal non-http and rootDomain routes. e.g: signUpStart route no reload required
  if (path) {
    return <Navigate replace to={path} />;
  }

  return <CenterFrameLayout title="Signing out..." showLoader />;
}
